import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const Quest: React.FC = () => {
    return (
        <Layout>
            <div>
                <p><Link to="/">top</Link></p>
                クエスト
            </div>
        </Layout>
    );
}

export default Quest;